import IcComment from '../../../assets/image/ic_comment.svg';
import { COMMUNITY_QNA_TYPE } from '../../../data/define';
import { useTranslation } from '../../../hook/useTranslation';
import moment from 'moment';

interface PostCardProps {
  post: any;
  onClick?: (id: number) => void;
  // Other props passed by Qna.tsx but not used directly
  optionClick?: (id: number) => void;
  isLoggedIn?: boolean;
  userId?: number;
}

function PostCard({ post, onClick }: PostCardProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="w-full px-[20px] py-[20px] flex flex-col gap-4 border-b border-[#EAEAEA]"
      onClick={() => onClick && onClick(post.id)}
    >
      <div className="flex items-center gap-2">
        <span className="text-[#363636] font-[400] text-[12px] rounded-[4px] px-[8px] py-[4px] bg-[#F8F8F8]">
          {post.questionType === COMMUNITY_QNA_TYPE.ANALYSIS ? t('community.qna.analysis_report') : t('community.qna.growth_change')}
        </span>
        <span className="text-[16px] font-[600] text-[#1C1C1C] flex-1 truncate text-left">
          {post.title}
        </span>
      </div>
      <div className="text-[14px] font-[400] text-[#363636] line-clamp-2 text-left leading-[1.6]">
        {post.content}
      </div>
      <div className="flex items-center justify-between">
        <div className="text-[12px] font-[400] text-[#969696] flex items-center justify-start gap-1">
          <span>{post?.user?.nickName || '익명'}</span>
          <span>|</span>
          <span>{moment(post.createdAt).fromNow()}</span>
        </div>
        <div className="flex items-center justify-end gap-2">
          {post.hasExpertAnswer && (
            <div className="text-[14px] font-[700] text-[#5EBEBB]">{t('community.qna.expert_answer')}</div>
          )}
          {post.hasExpertAnswer && post.commentCount > 0 && (
            <div className="text-[14px] font-[400] text-[#EAEAEA]">|</div>
          )}
          {post.commentCount > 0 && (
            <div className="flex items-center justify-center gap-1">
              <img src={IcComment} alt="comment" className="w-[18px] h-[18px]" />
              <div className="text-[14px] text-[#767676] font-[400] mt-[2px]">
                {post.commentCount}
              </div>
            </div>
          )}
        </div>
      </div>
    </button>
  );
}

export default PostCard;
